(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/self-exclusion-react/assets/react/components/self-exclusion-24-abtest.js') >= 0) return;  svs.modules.push('/modules/self-exclusion-react/assets/react/components/self-exclusion-24-abtest.js');
'use strict';

const Button = svs.ui.ReactButton;
const {
  useAtom
} = jotai;
const {
  Form
} = svs.ui.ReactForm;
const {
  activeExclusionsAtom
} = svs.selfExclusion.store.selfExclusionAtoms;
const SelfExclusion24AbTest = () => {
  const [, setActiveExclusions] = useAtom(activeExclusionsAtom);
  const confirmSelfExclusion24 = e => {
    e.preventDefault();
    svs.accountservices.pause24.show(activeExclusions => {
      setActiveExclusions(svs.accountservices.player_exclusions.utils.asArray(activeExclusions));
    });
  };
  return React.createElement("section", {
    className: "exclusion-pause-wrapper exclusion-rounded-corners padding-xs-h-2 padding-xs-bottom-2",
    id: "self-exclusion-24"
  }, React.createElement(Form, {
    onSubmit: confirmSelfExclusion24
  }, React.createElement("div", null, React.createElement("h3", {
    className: "align-center f-700 f-bold padding-top-2 margin-top-0",
    id: "self-exclusion-24-header"
  }, "Spelpaus i 24 timmar"), React.createElement("p", {
    className: "exclusion-text-align"
  }, "Pausen g\xE4ller spel hos oss p\xE5 Svenska Spel Sport & Casino.")), React.createElement(Button, {
    "aria-labelledby": "self-exclusion-24-header activate-24h-paus",
    block: true,
    id: "activate-24h-paus",
    size: 300,
    transparent: true,
    type: "submit"
  }, "Aktivera paus")));
};
svs.selfExclusion.components.SelfExclusion24AbTest = SelfExclusion24AbTest;

 })(window);